import DefaultAvatarIcon from 'assets/svgs/DefaultAvatarIcon';
import DocumentLayoutIcon from 'assets/svgs/DocumentLayoutIcon';
import PdfFileIcon from 'assets/svgs/PdfFileIcon';
import PlusIcon from 'assets/svgs/PlusIcon';
import { AddReferenceModal } from 'components/Modals/AddReferenceModal';
import { NewAddReferenceModal } from 'components/Modals/AddReferenceModal/NewAddReferenceModal';
import React, { useRef, useState } from 'react';

import './index.styles.scss';

interface ReferenceData {
  name: string;
  image: string;
  type: 'user' | 'file';
  text: string;
}
interface ReferenceProps {
  data: Array<ReferenceData>;
  itemId?: number;
  itemType?: 'user' | 'group' | 'organisation';
  showAddButton: boolean;
  showExpandButton?: boolean;
  setIsExpandReference: any;
  isExpandReference: boolean;
  onDoneAddReference?: (newUserRef, newFileRef) => void;
}

export const Reference = ({
  data,
  showAddButton,
  showExpandButton = true,
  itemId,
  itemType,
  setIsExpandReference,
  isExpandReference,
  onDoneAddReference
}: ReferenceProps) => {
  const addBtnRef = useRef<HTMLDivElement>(null);
  const [showAddDlg, setShowAddDlg] = useState(false);

  const [addDlgPos, setAddDlgPos] = useState({ top: 0, left: 0 });

  const onShowAddDlg = (e) => {
    setShowAddDlg(true);

    const clientRectangle = document!
      .getElementById('add_btn_ref')!
      .getBoundingClientRect();

    const bottomFromWindow = window.innerHeight - clientRectangle.top;
    setAddDlgPos({
      top:
        bottomFromWindow < 400
          ? clientRectangle.top - 400
          : clientRectangle.top,
      left: clientRectangle.left
    });
  };

  const renderUserRef = (refData: ReferenceData, index) => {
    return (
      <div className="reference_item_tt" key={`reference_item_${index}`}>
        {refData.image && refData.image.startsWith('https') ? (
          <img
            src={refData.image}
            style={{ width: 24, height: 24, borderRadius: 24 }}
          />
        ) : (
          <DefaultAvatarIcon size={24} />
        )}
      </div>
    );
  };

  const renderFileRef = (refData: ReferenceData, index) => {
    return (
      <div className="reference_item_tt" key={`reference_item_${index}`}>
        <div style={{ width: 24, height: 24 }}>
          <PdfFileIcon size={24} />
        </div>
        <div className="reference_name font-bold font12">{refData.name}</div>
      </div>
    );
  };

  const renderAddDlg = () => {
    return (
      <NewAddReferenceModal
        show={showAddDlg}
        itemId={itemId}
        itemType={itemType}
        posX={addDlgPos.left}
        posY={addDlgPos.top}
        onClose={() => setShowAddDlg(false)}
        onDone={(userRef, fileRef) => {
          setShowAddDlg(false);
          onDoneAddReference && onDoneAddReference(userRef, fileRef);
        }}
      />
    );
  };

  return (
    <div className="reference_container">
      {showExpandButton && data.length > 0 && (
        <div
          className={'reference_action_btn_tt clickable'}
          onClick={() => setIsExpandReference((prev: boolean) => !prev)}
        >
          <div>
            <DocumentLayoutIcon color={'#FF3E9A'} size={16} />
          </div>
        </div>
      )}
      {data.map((item, index) => {
        if (item.type === 'user') return renderUserRef(item, index);
        else return renderFileRef(item, index);
      })}
      {showAddButton && (
        <div
          ref={addBtnRef}
          id="add_btn_ref"
          className="reference_item_tt clickable"
          style={{ width: 170 }}
          onClick={onShowAddDlg}
        >
          <PlusIcon />
          <div
            className="font-bold font14"
            style={{ marginLeft: 8, width: 110 }}
          >
            Set references
          </div>
        </div>
      )}
      {renderAddDlg()}
    </div>
  );
};
